(() => {
  if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
  const prior=window.__upvineAnniversaryAnalytics;
  if(prior?.body===document.body&&prior.path===location.pathname)return;
  prior?.stop?.();
  const lifetime=new AbortController();
  document.documentElement.dataset.uv10AnalyticsState='waiting-privacy';
  window.__upvineAnniversaryAnalytics={body:document.body,path:location.pathname,stop(){lifetime.abort();observer?.disconnect();mutation?.disconnect();clearTimeout(privacyTimer);for(const t of timers.values())clearTimeout(t);}};
  const endpoint = 'https://upvine-custom-statistics.upvine001.workers.dev/api/anniversary/collect';
  const campaignPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/10th-anniversary\/?$/i;
  const productEntryPaths={'/products/gravel-disc-wheelset':'product_gravel','/products/light-disc-wheelset':'product_light','/products/ultra-disc-wheelset':'product_ultra','/products/pro-plus-disc-wheelset':'product_pro_plus','/products/pro-disc-wheelset':'product_pro'};
  const normalizedPath=location.pathname.toLowerCase().replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/,'').replace(/\/$/,'')||'/';
  const bannerEntry=normalizedPath==='/'?'home':productEntryPaths[normalizedPath];
  const page = crypto.randomUUID(), seen = new Set(), watched = new WeakSet(), timers = new Map();
  const storageGet = (store,key) => {try{return JSON.parse(window[store].getItem(key));}catch{return null;}};
  const storageSet = (store,key,value) => {try{window[store].setItem(key,JSON.stringify(value));}catch{}};
  const storageRemove = (store,key) => {try{window[store].removeItem(key);}catch{}};
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let visitor, started=false, observer, mutation, source='other', qaRun='',privacyTimer=null,privacyLoading=false,privacyAttempts=0;
  const device = () => matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  function send(event,target,representative='') {
    if (lifetime.signal.aborted || !permitted() || document.visibilityState !== 'visible') return;
    const payload={id:crypto.randomUUID(),visitor,page,event,target,representative,source,device:device(),path:location.pathname,qaRun};
    const body=JSON.stringify(payload);
    if (!navigator.sendBeacon?.(endpoint,new Blob([body],{type:'text/plain;charset=UTF-8'}))) fetch(endpoint,{method:'POST',body,headers:{'Content-Type':'text/plain;charset=UTF-8'},keepalive:true,credentials:'omit'}).catch(()=>{});
  }
  function once(event,target) { const key=event+':'+target; if (seen.has(key) || !permitted() || document.visibilityState!=='visible') return; seen.add(key);send(event,target); }
  const visibleEnough=el=>{
    if(document.visibilityState!=='visible'||!permitted())return false;
    const r=el.getBoundingClientRect(),style=getComputedStyle(el);
    return style.visibility!=='hidden'&&style.display!=='none'&&r.width>0&&r.height>0&&Math.max(0,Math.min(r.bottom,innerHeight)-Math.max(r.top,0))>=Math.min(r.height,innerHeight)*.5&&Math.max(0,Math.min(r.right,innerWidth)-Math.max(r.left,0))>=Math.min(r.width,innerWidth)*.5;
  };
  function watch(el,event,target){
    if(!el||watched.has(el))return;watched.add(el);el.dataset.uv10Analytics=event+':'+target;observer.observe(el);
  }
  function scan(){
    if(bannerEntry)for(const button of document.querySelectorAll('#upvine-home-anniversary .uv4-cta'))watch(button,'entry_impression',bannerEntry);
    for(const a of document.querySelectorAll('header a[href],.header__inline-menu a[href],#menu-drawer a[href],.menu-drawer a[href]')){
      try{if(campaignPath.test(new URL(a.href,location.origin).pathname))watch(a,'entry_impression',a.closest('#menu-drawer,.menu-drawer,header-drawer')?'menu_mobile':'menu_desktop');}catch{}
    }
    if(!campaignPath.test(location.pathname))return;
    for(const card of document.querySelectorAll('#upvine-anniversary .uv10-product-card'))watch(card,'product_impression',card.id);
    const team=document.querySelector('#upvine-anniversary [data-team-source]');
    watch(team,'team_impression','team');
    for(const card of document.querySelectorAll('#upvine-anniversary .uv10-team-card')){
      const name=card.querySelector('.uv10-team-name')?.textContent.trim().toLowerCase();
      if(['dannie','jesse'].includes(name))watch(card,'representative_impression',name);
    }
  }
  function consider(){
    if(!started||lifetime.signal.aborted)return;
    if(campaignPath.test(location.pathname))once('page_view','campaign');
    for(const [el,timer]of timers)if(!visibleEnough(el)){clearTimeout(timer);timers.delete(el);}
    for(const el of document.querySelectorAll('[data-uv10-analytics]')){
      const [event,target]=el.dataset.uv10Analytics.split(':');
      if(seen.has(event+':'+target)||timers.has(el)||!visibleEnough(el))continue;
      timers.set(el,setTimeout(()=>{timers.delete(el);if(visibleEnough(el))once(event,target);},1000));
    }
  }
  function start(){
    if(lifetime.signal.aborted)return;
    document.documentElement.dataset.uv10AnalyticsState=permitted()?'active':'consent-disabled';
    if(!permitted()){
      for(const timer of timers.values())clearTimeout(timer);timers.clear();
      storageRemove('localStorage','upvine.anniversary.visitor.v1');storageRemove('sessionStorage','upvine.anniversary.entry.v1');return;
    }
    if(started){consider();return;}started=true;
    const now=Date.now(), saved=storageGet('localStorage','upvine.anniversary.visitor.v1');
    visitor=saved&&typeof saved.id==='string'&&saved.expires>now?saved.id:crypto.randomUUID();
    storageSet('localStorage','upvine.anniversary.visitor.v1',{id:visitor,expires:saved?.expires>now?saved.expires:now+90*86400000});
    const entry=storageGet('sessionStorage','upvine.anniversary.entry.v1');if(entry?.expires>now)source=entry.source;
    const qa=new URLSearchParams(location.search).get('uv10_qa');
    if(/^[0-9a-f-]{36}$/i.test(qa||''))storageSet('sessionStorage','upvine.anniversary.qa.v1',{id:qa,expires:now+30*60000});
    const storedQA=storageGet('sessionStorage','upvine.anniversary.qa.v1');if(storedQA?.expires>now)qaRun=storedQA.id;
    observer=new IntersectionObserver(()=>consider(),{threshold:Array.from({length:21},(_,i)=>i/20)});
    scan();consider();
    let scanQueued=false;mutation=new MutationObserver(()=>{if(scanQueued)return;scanQueued=true;requestAnimationFrame(()=>{scanQueued=false;scan();consider();});});mutation.observe(document.body,{childList:true,subtree:true});
    let scheduled=false;addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;consider();});}},{passive:true,signal:lifetime.signal});
    addEventListener('resize',consider,{signal:lifetime.signal});document.addEventListener('visibilitychange',consider,{signal:lifetime.signal});
    addEventListener('pageshow',event=>{if(event.persisted)consider();},{signal:lifetime.signal});
  }
  document.addEventListener('click',event=>{
    if(!event.isTrusted||!started||!permitted())return;
    const a=event.target.closest('a[href]');if(!a)return;
    let url;try{url=new URL(a.href,location.origin);}catch{return;}
    if(campaignPath.test(url.pathname)&&url.origin===location.origin){
      let target=a.closest('#upvine-home-anniversary')&&a.matches('.uv4-cta')?bannerEntry:a.closest('#menu-drawer,.menu-drawer,header-drawer')?'menu_mobile':a.closest('header,.header__inline-menu,.shopify-section-header')?'menu_desktop':null;
      if(target){storageSet('sessionStorage','upvine.anniversary.entry.v1',{source:target,expires:Date.now()+30*60000});send('entry_click',target);}
    }
    if(!campaignPath.test(location.pathname))return;
    const product=a.closest('.uv10-product-card');if(product&&a.matches('.uv10-product-link'))send('product_click',product.id);
    const card=a.closest('#upvine-anniversary .uv10-team-card');
    if(card){
      const name=card.querySelector('.uv10-team-name')?.textContent.trim().toLowerCase();
      const channel=url.protocol==='mailto:'?'email':url.protocol==='tel:'?'phone':url.hostname==='wa.me'?'whatsapp':url.hostname.endsWith('instagram.com')?'instagram':null;
      if(channel&&['dannie','jesse'].includes(name))send('contact_click',channel,name);
    }
  },{capture:true,signal:lifetime.signal});
  document.addEventListener('visitorConsentCollected',start,{signal:lifetime.signal});
  function retryPrivacy(){
    if(lifetime.signal.aborted)return;
    clearTimeout(privacyTimer);
    if(privacyAttempts>=8){document.documentElement.dataset.uv10AnalyticsState='privacy-load-error';return;}
    document.documentElement.dataset.uv10AnalyticsState='waiting-privacy';privacyTimer=setTimeout(loadPrivacy,750);
  }
  function loadPrivacy(){
    if(lifetime.signal.aborted)return;
    if(typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed==='function'){clearTimeout(privacyTimer);start();return;}
    if(privacyLoading)return;
    if(privacyAttempts>=8){retryPrivacy();return;}
    privacyAttempts++;
    if(window.Shopify?.loadFeatures){privacyLoading=true;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],()=>{privacyLoading=false;if(typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed==='function')start();else retryPrivacy();});}
    else retryPrivacy();
  }
  loadPrivacy();
  addEventListener('load',loadPrivacy,{once:true,signal:lifetime.signal});
})();
